import { render } from "./DeliveryZone.vue?vue&type=template&id=f1917f58&scoped=true"
import script from "./DeliveryZone.vue?vue&type=script&lang=js"
export * from "./DeliveryZone.vue?vue&type=script&lang=js"

import "./DeliveryZone.vue?vue&type=style&index=0&id=f1917f58&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1917f58"]])

export default __exports__